import { create } from 'zustand';

export interface AppNotification {
  id: string;
  type: 'alarm' | 'info' | 'success' | 'warning';
  title: string;
  body: string;
  at: number;         // Date.now()
  dismissed: boolean;
}

interface NotificationState {
  notifications: AppNotification[];
  unackedAlarms: number;
  add: (n: Omit<AppNotification, 'id' | 'at' | 'dismissed'>) => void;
  dismiss: (id: string) => void;
  dismissAll: () => void;
  setUnackedAlarms: (count: number) => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unackedAlarms: 0,

  add: (n) =>
    set((s) => ({
      notifications: [
        { ...n, id: `${Date.now()}-${Math.random()}`, at: Date.now(), dismissed: false },
        ...s.notifications.slice(0, 19),   // keep last 20
      ],
    })),

  dismiss: (id) =>
    set((s) => ({
      notifications: s.notifications.map((n) =>
        n.id === id ? { ...n, dismissed: true } : n,
      ),
    })),

  dismissAll: () =>
    set((s) => ({
      notifications: s.notifications.map((n) => ({ ...n, dismissed: true })),
    })),

  setUnackedAlarms: (count) => set({ unackedAlarms: count }),
}));
